import {
    formatData,
    getGaClientId,
    GA_CHECKOUT_CATEGORY,
    GA_EVENT_IMPRESSION_CLICK,
    GA_CHECKOUT_PAGE
} from '@common/Tracking';
import { pushEventToDataLayer } from '@helpers/dataLayer';
import { getVisitorDataCookieAsObject } from '@helpers/visitor';
import { TRACK_REAL_LIST_VALUE } from '../constants/GaTrackStorageKeys';

export const getImpressionClickRealList = list => list || localStorage.getItem(TRACK_REAL_LIST_VALUE) || null;

const impressionClick = (product, eventInfoCategory) => {
    const {
        id,
        name,
        brand,
        variant,
        category,
        position,
        has_sustainability_icon: hasSustainabilityIcon,
        list
    } = product;

    const realList = getImpressionClickRealList(list);

    const eventData = {
        ...formatData(getVisitorDataCookieAsObject()),
        ...App.Config.GaTrackingData,
        client_id: getGaClientId(),
        ecommerce: {
            currencyCode: App.Config.currency,
            click: {
                actionField: {
                    list: realList
                },
                products: [{
                    id,
                    name,
                    brand,
                    variant,
                    category,
                    position: position ? parseInt(position, 10) : null,
                    has_sustainability_icon: hasSustainabilityIcon
                }]
            }
        }
    };

    const eventInfo = {
        category: eventInfoCategory,
        action: 'productClick',
        label: 'Fake click',
        non_interaction: 1
    };

    pushEventToDataLayer(GA_EVENT_IMPRESSION_CLICK, eventInfo, eventData);
};

const cartView = eventInfoCategory => () => {
    const products = App.Config.GaCartData;

    if (typeof products !== 'undefined' && products.length > 0) {
        products.forEach((product) => {
            impressionClick(product, eventInfoCategory);
        });
    }
};

export const trackImpressionClick = (eventInfoCategory = GA_CHECKOUT_CATEGORY) => {
    if (App.Config.Controller === GA_CHECKOUT_PAGE) {
        window.addEventListener('load', cartView(eventInfoCategory));
    }
};
